module.exports = __webpack_public_path__ + "img/ttshop_tk1.0e30e9ff.svg";